import React, { useState, useEffect } from "react";
import fetchHook from "../../hooks/fetchMSSQL-hook";
import { NotificationManager } from "react-notifications";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";

export default function CopyMachineConfiguration({
  refMachineId,
  handleClose = () => {},
}) {
  const { fetchMssqlApi } = fetchHook();
  const [copyMachines, setCopyMachines] = useState([]);
  const [machinesList, setGetMachinesList] = useState([]);
  const [additionalConfig, setAdditionalConfig] = useState({});
  const [refMachine, setRefMachine] = useState({});
  const [results, setResults] = useState([]);

  const findMachineId = ({ machineName }) => {
    const machine = machinesList.find(
      (machine) => machine.Name === machineName
    );

    if (machine) {
      const machinesToCopy = copyMachines
        .map((machine) => machine.MachineId)
        .includes(machine.MachineId);

      if (machinesToCopy) {
        NotificationManager.warning("Maszyna już dodana");
      } else if (Number(machine.MachineId) === Number(refMachineId)) {
        NotificationManager.warning("Maszyna jest źródłową");
      } else {
        setCopyMachines((prev) => [...prev, machine]);
      }

      return true;
    }

    return false;
  };

  const findMachineById = ({ MachineId }) => {
    return machinesList.find(
      (machine) => Number(machine.MachineId) === Number(MachineId)
    );
  };

  const getSelectedMachines = () =>
    JSON.stringify(copyMachines.map((machine) => Number(machine.MachineId)));

  const getMachinesList = () =>
    fetchMssqlApi(`/machines-list`, {}, setGetMachinesList, (err) =>
      NotificationManager.error(String(err))
    );

  const getErrorMessage = (err) =>
    err?.response?.data?.message ||
    err?.data?.message ||
    err?.message ||
    (typeof err === "string"
      ? err
      : "Wystąpił błąd podczas kopiowania konfiguracji");

  const sendMachines = () => {
    const parsedOverwriteType = Number(additionalConfig.overwriteType);

    if (![1, 2].includes(parsedOverwriteType)) {
      NotificationManager.warning(
        "Nie wybrano żadnej opcji kopiowania"
      );
      return;
    }

    fetchMssqlApi(
      `/machine/copy-configuration`,
      {
        method: "POST",
        data: {
          refMachineId,
          machineIds: getSelectedMachines(),
          overriteType: parsedOverwriteType,
        },
        hideNotification: true,
      },
      (res) => {
        setResults(Array.isArray(res) ? res : []);
      },
      (err) => {
        NotificationManager.error(getErrorMessage(err));
      }
    );
  };

  const handleChangeInput = (e) => {
    const { value } = e.target;

    if (value) {
      const res = findMachineId({ machineName: value });

      if (res) {
        e.target.value = "";
      }
    }
  };

  const appendAdditionalConfig = (e) => {
    const { name, id } = e.target;

    if (name === "overwriteType") {
      setAdditionalConfig((prev) => ({
        ...prev,
        [name]: id,
      }));
    }
  };

  const deleteMachineFromSelected = ({ Name }) =>
    setCopyMachines((prev) =>
      prev.filter((machine) => machine.Name !== Name)
    );

  const clearAllMachines = () => {
    setCopyMachines([]);
  };

  useEffect(() => {
    getMachinesList();
  }, []);

  useEffect(() => {
    const currentMachine = machinesList.find(
      (machine) => Number(machine.MachineId) === Number(refMachineId)
    );

    if (currentMachine) {
      setRefMachine(currentMachine);
    }
  }, [machinesList, refMachineId]);

  return (
    <Modal onHide={handleClose} backdrop={true} size="lg" show={true} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          Kopiuj konfigurację {refMachine.Name || "automatu"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mb-4">
          <label className="form-label">Wybierz automaty docelowe:</label>
          <input
            className="form-control"
            placeholder="Automat"
            list="machines"
            name="machine"
            onChange={handleChangeInput}
            autoComplete="off"
            onFocus={(e) => {
              e.target.value = "";
            }}
          />
          <datalist id="machines">
            {machinesList &&
              machinesList.map((machine, idx) => (
                <option key={idx} value={machine.Name} />
              ))}
          </datalist>
        </div>

        <div className="mt-3">
          <label className="form-label d-block">Opcje kopiowania:</label>
          <div className="d-flex flex-wrap justify-content-start">
            <div className="form-check mr-4 mb-2 d-flex align-items-center">
              <input
                className="form-check-input"
                type="radio"
                id="2"
                value="UpdatePrice"
                name="overwriteType"
                onChange={appendAdditionalConfig}
              />
              <label htmlFor="2" className="form-check-label">
                Skopiuj cenę
              </label>
            </div>

            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip className="tooltip-machines">
                  <p>Nadpisuje konfigurację automatu</p>
                </Tooltip>
              }
            >
              <div className="form-check mb-2 d-flex align-items-center">
                <input
                  className="form-check-input"
                  type="radio"
                  id="1"
                  value="OverwriteSoft"
                  name="overwriteType"
                  onChange={appendAdditionalConfig}
                />
                <label htmlFor="1" className="form-check-label">
                  Skopiuj konfigurację
                </label>
              </div>
            </OverlayTrigger>
          </div>
        </div>

        <hr />

        <div name="chosen-machines" className="mb-4">
          <div className="d-flex justify-content-between mb-2">
            <div>
              <label className="form-label mb-0">Wybrane automaty:</label>
            </div>
            <div>
              <button
                className="btn btn-sm btn-danger mr-auto"
                onClick={clearAllMachines}
                disabled={copyMachines.length === 0}
              >
                Usuń wszystkie automaty
              </button>
            </div>
          </div>

          <div className="d-flex flex-wrap">
            {copyMachines && copyMachines.length > 0 ? (
              copyMachines.map((machine, idx) => (
                <div
                  key={idx}
                  className="badge badge-primary m-1 p-2 d-flex align-items-center"
                >
                  <span>{machine.Name}</span>
                  <button
                    className="btn btn-sm ml-2 p-0"
                    onClick={() => deleteMachineFromSelected(machine)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "white",
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              ))
            ) : (
              <div className="text-muted">Nie wybrano żadnego automatu</div>
            )}
          </div>

          {results.length ? (
            <div className="mt-3">
              <label className="form-label">Wyniki:</label>
              <ul className="list-group">
                {results.map((result, idx) => (
                  <li
                    key={idx}
                    className={`btn btn-${
                      Boolean(+result.Status) ? "success" : "danger"
                    } mb-2`}
                  >
                    {`${findMachineById(result)?.Name}: ${result.Message}`}
                  </li>
                ))}
              </ul>
            </div>
          ) : (
            <></>
          )}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="d-flex w-100 justify-content-between">
          <div>
            <button className="btn btn-secondary" onClick={handleClose}>
              Anuluj
            </button>
          </div>
          <div>
            <button
              className="btn btn-primary"
              onClick={sendMachines}
              disabled={!copyMachines.length}
            >
              Kopiuj konfigurację
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}